import { render, staticRenderFns } from "./custom-avatar-learn-more-dialog.vue?vue&type=template&id=17336a01"
import script from "./custom-avatar-learn-more-dialog.vue?vue&type=script&lang=js"
export * from "./custom-avatar-learn-more-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports